export const permissionsCost = [
  "cost",
  "everything-full",
  "everything-readonly",
];
